import React, { createContext, useContext, useState } from 'react';

interface HeaderSlotContextValue {
  isSlotClaimed: boolean;
  claimSlot: () => void;
  releaseSlot: () => void;
}

const HeaderSlotContext = createContext<HeaderSlotContextValue>({
  isSlotClaimed: false,
  claimSlot: () => {},
  releaseSlot: () => {},
});

export function HeaderSlotProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [isSlotClaimed, setIsSlotClaimed] = useState(false);

  return (
    <HeaderSlotContext.Provider
      value={{
        isSlotClaimed,
        claimSlot: () => setIsSlotClaimed(true),
        releaseSlot: () => setIsSlotClaimed(false),
      }}
    >
      {children}
    </HeaderSlotContext.Provider>
  );
}

export function useHeaderSlot(): HeaderSlotContextValue {
  return useContext(HeaderSlotContext);
}
